import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { container } from '@/app/container';
import { SalesRepositoryToken } from '../../di/tokens';
import type { ListOffersInput } from '../../data/datasources/sales-api.datasource';

type QueryFilters = Omit<ListOffersInput, 'page' | 'perPage'>;

/**
 * Lista paginada de ofertas (tela de Ofertas), ordenada por nome. A chave fica
 * sob `['sales', 'offers']` para o cadastro da campanha de garantia
 * (`useRegisterOffer`) invalidá-la.
 */
export function useOffers(page = 1, perPage = 10, filters: QueryFilters = {}) {
  const repository = container.resolve(SalesRepositoryToken);
  return useQuery({
    queryKey: ['sales', 'offers', 'list', page, perPage, filters],
    queryFn: () => repository.listOffers({ page, perPage, ...filters }),
    staleTime: 1000 * 60 * 5,
    placeholderData: keepPreviousData,
  });
}
